import Main from './Main'
import Lista from './components/OperadoraReboque'
import Novo from './components/NovaOperadoraReboque'

export default [
  {
    path: 'pc-operadora-reboque',
    name: 'policiacivil.processo.operadora-reboque',
    component: Main,
    redirect: { name: 'policiacivil.processo.operadora-reboque.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.operadora-reboque.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.operadora-reboque.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.operadora-reboque.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/operadora-reboque/operadora-reboque/routes.js